module.exports = __webpack_public_path__ + "img/partner_5.084d985.png";